var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 6.306C19 5.5133 18.3732 4.87065 17.6 4.87065L6.4 4.87068C5.6268 4.87068 5 5.5133 5 6.306V17.7886C5 18.5813 5.62533 19.2239 6.39853 19.2239H7.96409L5.3527 20.7538L6.0473 22L10.7859 19.2239H13.2141L17.9527 22L18.6473 20.7538L16.0359 19.2239H17.6015C18.3747 19.2239 19 18.5813 19 17.7886V6.306ZM17.6 13.4826V6.306H6.4V13.4826H17.6ZM14.8 16.3533C14.8 17.1456 15.4272 17.7886 16.2 17.7886C16.9728 17.7886 17.6 17.1456 17.6 16.3533C17.6 15.561 16.9728 14.9179 16.2 14.9179C15.4272 14.9179 14.8 15.561 14.8 16.3533ZM6.4 16.3533C6.4 17.1456 7.0272 17.7886 7.8 17.7886C8.5728 17.7886 9.2 17.1456 9.2 16.3533C9.2 15.561 8.5728 14.9179 7.8 14.9179C7.0272 14.9179 6.4 15.561 6.4 16.3533Z",
    fill: "#EB5A2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61847 3.73137C8.61847 3.73137 10.6 3.43532 12 3.43532C13.4 3.43532 15.3815 3.73137 15.3815 3.73137L16.0069 2.44721C16.0069 2.44721 14.1 2 12 2C9.9 2 7.9931 2.4472 7.9931 2.4472L8.61847 3.73137Z",
    fill: "#EB5A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram);
export default __webpack_public_path__ + "static/media/tram.5c596e7584b632280185787cc6bf7804.svg";
export { ForwardRef as ReactComponent };